<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <div class="row">
    <div class="col-md-12">

      <div class="page-breadcrumb">
        <ul class="page-breadcrumb__trail">
          <li><a>Manage</a></li>
          <li><a>Devices</a></li>
          <li><a>Devices</a></li>
        </ul>
      </div>

      <div class="block">
        <div class="page-header">
          <span class="page-header__title">Devices</span>
          <img src="assets/images/New_Icons/refresh-icon.svg" alt="Refresh icon" title="Refresh" class="page-header__icon" width="17" height="17" (click)="!enableDisablePageLoader ? ngOnInit() : null"/>
        </div>
        <div class="list_block">
          <div class="toolbar">
            <div class="toolbar__search">
              <img src="../../../../../../assets/images/New_Icons/search-icon.svg" alt="Search icon">
              <input type="text" (ngModelChange)="onSearchChanged()" [(ngModel)]="search" name="search" autocomplete="off" placeholder="Search by Serial Number / Model"/>
            </div>
            <div class="toolbar__spacer"></div>
            <div class="toolbar__add-button" (click)="openForm()">
              <button type="button">
                <span class="toolbar__add-icon">
                  <img src="../../../../../../assets/images/New_Icons/plus-icon.svg" alt="Add Icon"/>
                </span>
                <span class="toolbar__add-text">Add New</span>
              </button>
            </div>
          </div>
        </div>
        <div *ngIf="enableDisablePageLoader">
          <div class="adjust">
            <div class="loader2"></div>
          </div>
        </div>
        <div class="cards_container" *ngIf="!enableDisablePageLoader">
          <div class="card_wrapper" *ngFor="let device of devicesList; let i = index">
            <div class="master-card">
              <div class="master-card-header">
                <div class="master-card-title">
                  <img src="../../../../../../assets/images/New_Icons/card-heading.svg" alt="Left arrow icon">
                  <span>{{ device && (device.number || device.serial_number) }}</span>
                </div>
              </div>
              <div class="master-card-body">
                <div class="master-card-body-info">
                  <span class="card-content-text">Device Model:</span>
                  <span class="text">{{ device?.deviceModel?.name }}</span>
                </div>
                <div class="master-card-body-info">
                  <span class="card-content-text">Manufactured Date:</span>
                  <span class="text">{{ device?.manufactured_date | date: "dd MMM yyyy" }}</span>
                </div>
                <div class="master-card-body-info">
                  <span class="card-content-text">Created At:</span>
                  <span class="text">{{ device?.createdAt | date: "dd MMM yyyy" }}</span>
                </div>
              </div>
              <div class="master-card-footer">
                <div class="master-card-footer-info">
                  <span class="label">Updated At:</span>
                  <span class="text">{{ device?.updatedAt | date: "dd MMM yyyy" }}</span>
                </div>
                <div class="action-icons">
                  <a>
                    <img src="../../../../../../assets/images/New_Icons/edit.svg" alt="Edit icon" title="Edit Device" (click)="getDeviceById(device.id)">
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="listLoader" class="loader-div">
          <div class="adjust">
            <div class="loader2 list-loader"></div>
          </div>
        </div>
        <div *ngIf="noList && !enableDisablePageLoader" class="noDataFoundMessage">Devices Not Found</div>
      </div>

       <!--add/update form-->
      <div class="dynamic-form-wrapper" [ngClass]="{ 'floating-panel': formFieldCount <= 7, 'slide-in-overlay': formFieldCount > 7}" *ngIf="showForm">
        <div class="popup-wrapper">
          <button type="button" class="popup-close-beside" (click)="closeForm()" title="Close">&times;</button>
          <!-- Actual Popup -->
          <div [ngClass]="{ 'form-container-panel': formFieldCount > 7, 'popup-inner': formFieldCount <= 7}">
            <form [formGroup]="registerForm" novalidate>
              <div class="form-header">
                <div class="form-title">Device</div>
                <button type="button" class="add-update-submit-button" (click)="addUpdateDevice()" [disabled]="addDeviceDoubleClick">
                  <span class="icon"><img src="../../../../../../assets/images/New_Icons/tick-icon.svg" alt="Tick icon"></span>
                  <span class="text">{{ submitButton ? 'Submit' : 'Update' }}</span>
                </button>
              </div>
              <div class="form-container">
                <!-- Device Model -->
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Device Model</mat-label>
                  <mat-select id="deviceModel" formControlName="modelId">
                    <mat-option value="" disabled>Select Device Model</mat-option>
                    <mat-option *ngFor="let model of deviceModels" [value]="model.id"> {{ model.name }} </mat-option>
                  </mat-select>
                  <mat-hint *ngIf="f.modelId.invalid"><i>Select Device Model</i></mat-hint>
                  <mat-hint *ngIf="f.modelId.valid"><i>Device Model Selected</i></mat-hint>
                  <mat-error *ngIf="(f.modelId.touched || f.modelId.dirty || submitted) && f.modelId.hasError('required')">
                    <i>Required.</i>
                  </mat-error>
                </mat-form-field>
                <!--Manufactured Date-->
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Manufactured Date</mat-label>
                  <input matInput [matDatepicker]="frompicker" formControlName="manufacturedDate" placeholder="Choose date" autocomplete="off" readonly
                  [max]="maxDate"/>
                  <mat-datepicker-toggle matSuffix [for]="frompicker"></mat-datepicker-toggle>
                  <mat-datepicker #frompicker></mat-datepicker>
                  <mat-error *ngIf="(f.manufacturedDate.touched || f.manufacturedDate.dirty || submitted) && f.manufacturedDate.hasError('required')">
                    <i>Manufactured date is required.</i>
                  </mat-error>
                </mat-form-field>
                <!--Serial Number-->
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Serial Number</mat-label>
                  <input matInput id="deviceNumber" type="text" formControlName="number" autocomplete="off" placeholder="Enter serial number"/>
                  <mat-error *ngIf="(f.number.dirty || f.number.touched || submitted) && f.number.errors">
                    <i> {{ f.number.hasError('required') ? 'Serial number is required.' : '' }}</i>
                  </mat-error>
                </mat-form-field>
              </div>
            </form>
          </div>
        </div>
      </div>
      <!--add/update form end-->
    </div>
  </div>
</div>

